
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/assessment",
      function () {
        return require("private-next-pages/resources/assessment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/assessment"])
      });
    }
  